<script lang="ts" setup>
const isVisible = ref(false)

const onClose = () => {
  localStorage.setItem('cookiesShowed', 'true')
  isVisible.value = false
}

onMounted(() => {
  if (!localStorage.getItem('cookiesShowed')) isVisible.value = true
})
</script>

<template>
  <transition name="height">
    <noindex v-if="isVisible" class="cookies" data-e2e="the-cookies-banner">
      <div class="cookies__container">
        <nuxt-img
          class="cookies__icon"
          src="/cookies-icon.svg"
          alt="Мы используем куки"
        />

        <div class="cookies__text">
          Продолжая пользоваться сайтом, вы&nbsp;принимаете
          <nuxt-link
            to="/confidential/"
            class="cookies__description-link"
            @click.prevent="onClose"
          >
            cookie
          </nuxt-link>
        </div>

        <the-button
          class="cookies__button"
          icon="cancel"
          variant="tertiary"
          icon-size="12"
          size="xxs"
          width="20"
          height="20"
          @click="onClose"
        />
      </div>
    </noindex>
  </transition>
</template>

<style lang="scss" scoped>
@use '@/assets/styles/animations.scss' as *;

.cookies {
  position: fixed;
  bottom: calc(66px + env(safe-area-inset-bottom, 0px));
  left: 0;
  z-index: 111;
  display: flex;
  justify-content: center;
  width: 100%;

  @include media('>=desktop-mini') {
    bottom: 0;
  }

  &__container {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 6px 20px;
    background: var(--ui-color-white);
    border-radius: 12px 12px 0 0;
    box-shadow: var(--ui-shadow-top);

    @include media('>=tablet') {
      max-width: 462px;
      padding: 8px;
    }
  }

  &__text {
    margin-right: 6px;
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    color: var(--ui-text-primary);
    letter-spacing: -0.01em;

    @include media('>=tablet') {
      font-size: 14px;
      line-height: 18px;
    }

    a {
      color: var(--ui-color-primary);
      text-decoration: underline;
    }
  }

  &__icon {
    width: 14px;
    height: 14px;
    margin-right: 6px;

    @include media('>=tablet') {
      width: 16px;
      height: 16px;
    }
  }

  &__button {
    margin-left: auto;
  }
}
</style>
